import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ReportService} from '../../../../../feature-power/rp/service/api/report.service';
import {JobStatMenuItem} from '../../../interface/job-stat-menu.interface';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {ObjectIdentifierData} from '../../../../../core/shared/basic/object-identifier-data';
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';

@Component({
    selector: 'jb-job-group-batch-overview-component',
    templateUrl: 'jb-job-group-batch-overview.component.html',
    standalone: false
})
export class JbJobGroupBatchOverviewComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    filterCriteria: FilterCriteria[] = [];
    stats: JobStatMenuItem[];
    jobOverviewReportWidget: WidgetData;

    constructor(protected router: Router, protected route: ActivatedRoute, private reportService: ReportService) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshReportWidget();
        this.handleOverviewStats();
        this.initialized = true;
    }

    handleFilterCriteria(filter: FilterCriteria) {
        const index = this.filterCriteria.findIndex(criteria => criteria.field === 'e.start_time');
        if (index !== -1) {
            this.filterCriteria.splice(index, 1);
        }
        this.filterCriteria.push(filter);

        this.refreshReportWidget();
        this.handleOverviewStats();

    }

    handleOverviewStats() {
        this.reportService.getReport('jb', 0, ObjectRequestList.createBasic(false, this.filterCriteria, [])).subscribe(res => {
            const data = res.entries[0];
            this.stats = [
                {
                    label: 'Ausgeführte Jobs',
                    value: <string>data?.['total_jobs_executed'],
                    icon: 'fa-regular fa-gear',
                    color: '#007bff',
                    navigate: true,
                    status: 'All'
                },
                {
                    label: 'Laufende Jobs',
                    value: <string>data?.['running_jobs'],
                    icon: 'fa-regular fa-play',
                    color: '#00bcd4',
                    status: 'Started',
                    navigate: true
                },
                {
                    label: 'Erfolgreiche Jobs',
                    value: <string>data?.['successful_jobs'],
                    icon: 'fa-regular fa-circle-check',
                    color: '#4caf50',
                    status: 'Completed',
                    navigate: true
                },
                {
                    label: 'Fehlgeschlagene Jobs',
                    value: <string>data?.['failed_jobs'],
                    icon: 'fa-regular fa-circle-xmark',
                    color: '#f44336',
                    status: 'Failed',
                    navigate: true
                },
                {
                    label: 'Durchschn. Laufzeit',
                    value: <string>this.formatDuration(data?.['avg_execution_time']),
                    icon: 'fa-regular fa-clock',
                    color: '#ff9800',
                    navigate: false,
                },
                {
                    label: 'Gesamtlaufzeit',
                    value: <string>this.formatDuration(data?.['total_execution_time']),
                    icon: 'fa-regular fa-clock',
                    color: '#ff9800',
                    navigate: false,
                }
            ];
        });
    }

    formatDuration(isoDuration: string): string {
        const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
        const [, hours, minutes, seconds] = isoDuration.match(regex) || [];

        return [
            hours ? `${hours}h` : '',
            minutes ? `${minutes}m` : '',
            seconds ? `${seconds}s` : ''
        ].filter(Boolean).join(' ');
    }

    refreshReportWidget() {

        const objectRequestList = ObjectRequestList.createBasic(
            true,
            this.filterCriteria,
            []);

        this.jobOverviewReportWidget = WidgetFactory.createWidget(
            'jb.job.batch.overview.report.widget',
            'Job Batch Übersicht',
            'table',
            'list',
            'report',
            'jb.run.1'
        );
        this.jobOverviewReportWidget.dataProviderListRequest = objectRequestList;
    }

    handleObjectSelect(object: ObjectIdentifierData | ObjectIdentifier) {
        let event = object as ObjectIdentifierData;
        const jobName = event.data['job_name'];
        this.navigateToObject(jobName);
    }

    navigateToObject(jobName: string) {
        this.router.navigate(['job', jobName], {relativeTo: this.route.parent});
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['id']) {
            this.refreshComponent();
        }
    }
    handleStatClick(stat: JobStatMenuItem){
        if (!stat.navigate) return;

        this.router.navigate(['stat',stat.status], {
            relativeTo: this.route.parent,
        });
    }
    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
